import React, { Fragment } from "react";
import { withStyles } from "material-ui/styles";
import ResultIndexByQuestion from "components/ReportDetail/ResultIndexByQuestion.jsx";
import ErrorMessage from "components/ErrorMessage";
import Loader from 'react-loader-spinner';

const styles = () => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100
  },
  reportTitle: { fontSize: 30, textAlign: "center" },
  chapter: {
    paddingTop: 70,
    paddingLeft: 20
  },
  chapterTitle: {
    fontSize: 20,
    fontWeight: 600,
    textAlign: "center"
  },
  section: {
    paddingLeft: 0
  },
  sectionTitle: {
    fontWeight: 600,
    display: "inline-block"
  },
  result: {
    marginBottom: 50
  },
  table: {
    width: 1280,
    marginLeft: 20,
    fontSize: 10,
    padding: 0,
    textAlign: "center",
    borderCollapse: "collapse"
  },
  qTd: {
    padding: 0,
    textAlign: "center",
    border: "solid 1px lightgray"
  },
  mTd: {
    paddingLeft: 5,
    paddingRight: 5,
    textAlign: "center",
    border: "solid 1px lightgray"
  },
  qTextTd: {
    width: 23,
    verticalAlign: "middle",
    textAlign: "center",
    paddingLeft: 1,
    paddingRight: 1,
    border: "solid 1px lightgray",
    margin: "auto"
  },
  tSpan: {
    textAlign: "left",
    paddingTop: 5,
    minHeight: 160,
    "-webkit-writing-mode": "vertical-rl",
    "-ms-writing-mode": "tb-rl",
    "writing-mode": "vertical-rl"
  },
  errorMessage: {
    margin: 10
  }
});

class ResultIndexReport extends React.Component {
  componentWillMount() {
    this.props.fetchResultIndexReport();
  }
  componentWillUnmount() {
    this.props.initResultIndexReport();
  }
  render() {
    const { classes, resultIndexReport } = this.props;
    const {
      resultIndexByQuestion,
      questions,
      measureSize,
      errors
    } = resultIndexReport;
    if (errors.length > 0) {
      return (
        <ErrorMessage messages={errors} className={classes.errorMessage} />
      );
    }
    return (
      <Fragment>
        {/* ここだけwidthを1200に上書き */}
        <div
          style={{
            paddingTop: 30,
            backgroundColor: "white",
            paddingBottom: 30
          }}
        >
          <div className={classes.reportTitle}>NiserES 調査結果 添付資料</div>
          <section className={classes.chapter} id="summary">
            <div className={classes.chapterTitle}>質問別結果指数　一覧</div>
            <div className={classes.result}>
              <span className={classes.sectionTitle} />
            </div>
          </section>
          { (resultIndexByQuestion.length === 0) ?
                 (
                   <div style={{ margin: "100px auto", textAlign: "center" }} >
                     <Loader
                       type="RevolvingDot"
                       color="#575962"
                       height="100"
                       width="100"
                     />
                   </div>
                 )
              :
              (
                <Fragment>
                  <ResultIndexByQuestion data={resultIndexByQuestion} />
                  <table className={classes.table}>
                    <tbody>
                      <tr>
                        <td className={classes.qTd} />
                        {questions.map(v => (
                          <td
                            key={`q-no-${v.id}`}
                            className={classes.qTd}
                            style={{ backgroundColor: v.color }}
                          >
                            {v.id}
                          </td>
                ))}
                      </tr>
                      <tr>
                        <td className={classes.mTd}>領域</td>
                        {measureSize.map(v => {
                  return v.col === 1 ? (
                    <td
                      key={v.title}
                      colSpan={v.col}
                      className={classes.mTd}
                      style={{ backgroundColor: v.color }}
                    >
                      {v.title}
                    </td>
                  ) : (
                    <td
                      key={v.title}
                      colSpan={v.col}
                      className={classes.mTd}
                      style={{ backgroundColor: v.color }}
                    >
                      {v.title}
                    </td>
                  );
                })}
                      </tr>
                      <tr>
                        <td className={classes.qTextTd}>
                          <span className={classes.tSpan}>項目</span>
                        </td>
                        {questions.map(v => (
                          <td
                            key={`q-text-${v.id}`}
                            className={classes.qTextTd}
                            style={{ backgroundColor: v.color }}
                          >
                            <span className={classes.tSpan}>{v.title}</span>
                          </td>
                ))}
                      </tr>
                    </tbody>
                  </table>
                </Fragment>
        )}
        </div>
      </Fragment>
    );
  }
}

export default withStyles(styles)(ResultIndexReport);



// WEBPACK FOOTER //
// ./src/components/ReportDetail/ResultIndexReport.jsx